import React from 'react';

interface Props {}

const ItemThumbnailGrid: React.FC<Props> = ({ children, ...props }) => (
  <div
    {...props}
    className="grid gap-2 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 xl:gap-4"
    role="grid"
  >
    {children}
  </div>
);

export default ItemThumbnailGrid;
